import { MalimaxDashboard } from "./malimax-dashboard";

export const ClientAdministratorComponent = ({
  options,
}: {
  options: any[];
}) => <MalimaxDashboard options={options} />;
